import { formatMoney } from "@/utils/generalUtilities";
import ProgressBar from "../ProgressBar/ProgressBar";
import Tooltip from "../Tooltip";

interface ProgressCardProps {
  headerOne: string;
  headerOneDesc: string;
  headerTwo: string;
  headerTwoDesc: string;
  current: number;
  target: number;
  percentage: string;
  children?: React.ReactNode;
  className?: string;
  showTooltip?: boolean;
  tooltipText?: string;
}

const ProgressCard = ({
  headerOne,
  headerOneDesc,
  headerTwo,
  headerTwoDesc,
  current,
  target,
  percentage,
  className = "",
  showTooltip,
  tooltipText,
}: ProgressCardProps) => (
  <div
    className={`border rounded-xl bg-gradient-to-b border-b-4 border-[#E1FBFB] from-[#E1FBFB] to-[#F6FFFF] py-8 w-full px-5 ${className}`}
  >
    <span>
      <span className="font-semibold">{headerOne}</span> {headerOneDesc}
      {showTooltip && tooltipText && (
        <span className="text-[18px] ml-1">
          <Tooltip text={tooltipText || ""} />
        </span>
      )}
    </span>
    <div className="flex justify-between items-center">
      <p className="mt-2 font-semibold">
        {headerTwo} <span>{headerTwoDesc}</span>
      </p>
      <p className="hidden md:block">
        $ {formatMoney(Math.trunc(current))} / ${" "}
        {formatMoney(Math.trunc(target))}
      </p>
    </div>
    <ProgressBar percentage={parseFloat(percentage)} />
  </div>
);

export default ProgressCard;
